import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoodsTags from './goodsTags.vue';
import { env } from '@ivy/fts/envInfo/envInfo';
import { convertPxToVw } from '../../utils';
let Goods = class Goods extends Vue {
    constructor() {
        super(...arguments);
        this.goodsClass = 'one-line';
        this.timer = null;
        this.getback = false; // 会员价背景色
        this.vipPricebackWidth = 0;
        this.vipShip = 3443.0;
    }
    templateChange(newV) {
        this.goodsClass = newV + '-line-wrap';
    }
    // @Watch('data.goods', { deep: true })
    // goodsChanged(newV) {
    //   this.openTimer(newV)
    // }
    goodsEndTimeChanged(newV) {
        if (!newV) {
            this.closeTimer();
        }
        else {
            this.openTimer();
        }
    }
    get getTags() {
        return tags => {
            try {
                let _tags = JSON.parse(tags);
                return (_tags || []).length > 0;
            }
            catch (e) {
                return false;
            }
        };
    }
    get getSrc() {
        return item => {
            return item.from === 'sku'
                ? item._sku.cover.split(';;')[0] || item.cover.split(';;')[0] || ''
                : item.cover.split(';;')[0];
        };
    }
    get getTitleSrc() {
        return item => {
            return item.from === 'sku' ? item._sku.title : item.title;
        };
    }
    get getState() {
        return item => {
            return item.from === 'sku' ? item._sku.state : item.state;
        };
    }
    get filterList() {
        return this.data.goods.filter(good => {
            if (!this.data.showPublish) {
                return good.from === 'sku' ? good._sku.state === 1 : good.state === 1;
            }
            if (!this.data.showSellOut) {
                return !this.isSaleOut(good);
            }
            return good;
        });
    }
    get needEndTimer() {
        return item => {
            let { _activity = {} } = item;
            let isLimit = _activity.activityType === 'limitbuy';
            let isGroup = _activity.activityType === 'group';
            // if (isLimit) {
            //   return new Date(_activity.endTime).getTime() > new Date().getTime()
            // }
            return isLimit || isGroup;
        };
    }
    get isGroup() {
        return item => {
            let { _activity = {} } = item;
            return _activity.activityType === 'group'
                ? _activity.groupNum + '人团'
                : '';
        };
    }
    get isLimit() {
        return item => {
            let { _sku = {}, _activity = {} } = item;
            let isLimit = _activity.activityType === 'limitbuy';
            if (!isLimit) {
                return '';
            }
            let limitPrice = parseFloat(_activity.salePrice);
            let skuPrice = parseFloat(_sku.originSalePrice);
            let text = '';
            if (limitPrice === 0 || skuPrice === 0) {
                text = '0折';
            }
            else {
                let re = ((limitPrice * 10) / (skuPrice * 10)) * 10 + '';
                if (re.indexOf('.') > -1) {
                    // 有小数点
                    text = re.split('.')[0] + '.' + re.split('.')[1][0] + '折';
                }
                else {
                    text = +re + '折';
                }
            }
            return isLimit ? text : '';
        };
    }
    get isSaleOut() {
        return item => item._sku.virtualInventoryQty <= 0;
    }
    get getSalePrice() {
        return item => {
            let { _sku = {}, _activity = {} } = item;
            let isLimit = _activity.activityType === 'limitbuy';
            let isGroup = _activity.activityType === 'group';
            if (Object.keys(_activity).length > 0) {
                if (isLimit) {
                    return parseFloat(_sku.salePrice) || '免费';
                }
                else if (isGroup) {
                    return parseFloat(_sku.salePrice) || '免费';
                }
            }
            else {
                return typeof _sku.salePrice === 'undefined'
                    ? ''
                    : parseFloat((+_sku.salePrice).toFixed(2)) || '免费';
            }
        };
    }
    get getQi() {
        return item => {
            return item.specification === 2 ? '' : '';
        };
    }
    get showOrigin() {
        return item => {
            return item._sku.originPrice ? +item._sku.originPrice : '';
        };
    }
    get vipPrice() {
        return item => {
            return item._sku.vipPrice && item._sku.activityType === 'vipPrice'
                ? parseFloat(item._sku.vipPrice)
                : '';
        };
    }
    get goodsList() {
        return [];
    }
    get count() {
        return ({
            one: 1,
            two: 2,
            three: 3,
            four: 4,
            five: 5,
        }[this.data.lineRule] || 1);
    }
    get lineRuleClass() {
        return `${this.data.lineRule}-line`;
    }
    get getDefaultSrc() {
        return require(`../../images/pic-${this.data.lineRule}.png`);
    }
    get goodsBoxStyle() {
        return {
            padding: `0 ${convertPxToVw(this.data.compMargin)}vw`,
            background: this.data.bgColor,
            'margin-left': `-${convertPxToVw(this.data.spacing / 2)}vw`,
            'margin-right': `-${convertPxToVw(this.data.spacing / 2)}vw`,
        };
    }
    get whiteStyle() {
        if (this.canShowWhite) {
            return {
                background: this.data.whiteCard
                    ? '#fff'
                    : this.data.bgColor || '#f5f6f6',
                padding: '8px 5px 5px 5px',
            };
        }
        return {};
    }
    get canShowWhite() {
        return this.data.lineRule === 'two' || this.data.lineRule === 'three';
    }
    get goodsConStyle() {
        if (this.canShowWhite) {
            if (this.data.whiteCard) {
                return {
                    margin: `${this.data.spacing / 2}px`,
                    'border-radius': this.data.radius + 'px',
                    background: '#fff',
                    padding: this.data.lineRule === 'three' ? '0px' : '8px',
                };
            }
            else {
                return {
                    margin: `${this.data.spacing / 2}px`,
                    'border-radius': this.data.radius + 'px',
                    background: this.data.bgColor || '#f5f6f6',
                    padding: '0px',
                };
            }
        }
        else {
            return {
                margin: `${this.data.spacing / 2}px`,
                'border-radius': this.data.radius + 'px',
                background: this.data.lineRule === 'one'
                    ? '#fff'
                    : this.data.bgColor || '#f5f6f6',
            };
        }
    }
    get textStylesimoe() {
        return {
            'text-align': this.data.fontAlign,
            'font-size': this.data.lineRule === 'one'
                ? '13px'
                : this.data.lineRule === 'two'
                    ? '11px'
                    : this.data.lineRule === 'three'
                        ? '11px'
                        : '',
        };
    }
    get smalltext() {
        return {
            'text-align': this.data.fontAlign,
            'font-weight': this.data.fontWeight,
            'font-size': this.data.lineRule === 'one'
                ? '14px'
                : this.data.lineRule === 'two'
                    ? '14px'
                    : this.data.lineRule === 'three'
                        ? '11px'
                        : '',
        };
    }
    get smalltextStyle() {
        return {
            'text-align': this.data.fontAlign,
            'font-weight': this.data.fontWeight,
            'font-size': this.data.lineRule === 'one'
                ? '18px'
                : this.data.lineRule === 'two'
                    ? '18px'
                    : this.data.lineRule === 'three'
                        ? '16px'
                        : '',
        };
    }
    get smtextStyle() {
        return {
            'text-align': this.data.fontAlign,
            'font-weight': this.data.fontWeight,
            'font-size': this.data.lineRule === 'one'
                ? '11px'
                : this.data.lineRule === 'two'
                    ? '11px'
                    : this.data.lineRule === 'three'
                        ? '9px'
                        : '9px',
        };
    }
    get textStyle() {
        return {
            'text-align': this.data.fontAlign,
            'font-weight': this.data.fontWeight,
        };
    }
    get imgStyle() {
        return {
            'object-fit': this.data.filling,
        };
    }
    get groupActivity() {
        return item => {
            return item.group ? '2人团' : '';
        };
    }
    async created() {
        this.goodsClass = this.data.lineRule + '-line-wrap';
        this.loadData();
        // 计算vip标签款酷
    }
    async loadData() {
        if (this.data.goods.length === 0) {
            return;
        }
        let spuIds = this.data.goods
            .filter(item => item._goodsType === 'goods')
            .map(item => item.id);
        let skuIds = this.data.goods
            .filter(item => item._goodsType === 'goods' && item._isSku)
            .map(item => item._sku.id);
        let spuIdsG = this.data.goods
            .filter(item => item._goodsType === 'group')
            .map(item => item.id);
        let skuIdsG = this.data.goods
            .filter(item => item._goodsType === 'group' && item._isSku)
            .map(item => item._sku.id);
        if (spuIds.length === 0 && spuIdsG.length === 0) {
            spuIds = this.data.goods.map(item => item.id);
        }
        let goodsData = {};
        let groupData = {};
        if (spuIds.length !== 0) {
            let { data: goodsDataL } = await this.$axios.get('/api/goods/shop/market/microPage/getGoodsInfos', {
                params: {
                    spuIds: Array.from(new Set(spuIds)),
                    skuIds: Array.from(new Set(skuIds)),
                },
            });
            goodsData = goodsDataL;
        }
        if (spuIdsG.length !== 0) {
            let { data: groupDataL } = await this.$axios.get('/api/goods/shop/market/microPage/getGroupGoodsInfos', {
                params: {
                    spuIds: Array.from(new Set(spuIdsG)),
                    skuIds: Array.from(new Set(skuIdsG)),
                },
            });
            groupData = groupDataL;
        }
        let arr = []
            .concat((goodsData.list || []).map(item => {
            return this.setRow(item, 'goods');
        }))
            .concat((groupData.list || []).map(item => {
            return this.setRow(item, 'group');
        }));
        let res = [];
        let sortBase = this.data.newGoodsIds || [];
        // 排序
        console.log('排序', sortBase);
        sortBase.forEach(item => {
            let keyAry = item && item.split('-');
            let item2 = arr.find(i => {
                if (i.from === 'spu') {
                    return i.id === +keyAry[0];
                }
                else {
                    return (i.id === +keyAry[0] &&
                        (+keyAry[1] === i._sku.id ||
                            keyAry[1] === 'sku' ||
                            Object.keys(i._sku).length === 0));
                }
            });
            res.push(item2);
        });
        this.data.goods = res.length ? res : arr;
        console.log('渲染的商品信息', this.data, this.data.goods);
        this.openTimer();
    }
    async mounted() {
        env.type === 'ivydad' && env.init();
    }
    setRow(row, type) {
        let selectActivity = row.skuInfo ? row.skuInfo.activities || {} : {};
        let selectActivityInfo = selectActivity.limitbuy || selectActivity.group || {};
        row._sku = row.skuInfo || {};
        row._activity = selectActivityInfo || {};
        // row.goods_tags = ['夕阳渐落天下', '梦里不知年华啊啊', '嘟嘟嘟']
        return row;
    }
    closeTimer() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
    openTimer(newGoods) {
        if (!this.data.showActivityDeadtime) {
            return;
        }
        newGoods = newGoods || this.data.goods || [];
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        let needTimer = newGoods.some(good => Object.keys(good._activity).length > 0);
        if (needTimer) {
            this.closeTimer();
            let endMap = {
                limitbuy: 'endTime',
                group: 'endTime',
                presell: 'presellEndTime',
                will_out: 'planUnpublishTime',
                will_sale: 'planPublishTime',
            };
            this.timer = setInterval(() => {
                newGoods.forEach(good => {
                    let hasActivity = good._activity && Object.keys(good._activity).length > 0;
                    if (hasActivity) {
                        // 判断是拼团还是预售，拼团的话需要分时间段
                        let isGroup = good._activity.activityType === 'group';
                        let isLimit = good._activity.activityType === 'limitbuy';
                        if (isGroup) {
                            this.setGroupTime(good, endMap);
                        }
                        else if (isLimit) {
                            this.setLimitTime(good, endMap);
                        }
                    }
                });
            }, 1000);
        }
    }
    setLimitTime(good, endMap) {
        let { effectiveTime: times, showWillBegin } = good._activity;
        if (times && times.length === 0)
            return;
        let now = Date.now();
        let startTimer;
        let endTimer;
        // 找到所处的时间段
        for (const time of times) {
            let { startTime, endTime } = time;
            let s = new Date(startTime.replace(/-/g, '/')).getTime();
            let n = new Date(endTime.replace(/-/g, '/')).getTime();
            if (showWillBegin) {
                if (now < s) {
                    startTimer = startTime;
                    break;
                }
                if (now < n) {
                    endTimer = endTime;
                    break;
                }
            }
            else {
                if (now < n) {
                    endTimer = endTime;
                    break;
                }
            }
        }
        if (startTimer || endTimer) {
            this.updateGood(good, startTimer || endTimer, startTimer);
        }
    }
    setGroupTime(good, endMap) {
        let end = good._activity[endMap[good._activity.activityType]];
        if (end) {
            this.updateGood(good, end);
        }
    }
    updateGood(good, end, startTimer) {
        let msec = new Date((end + '').replace(/-/g, '/')).getTime() - new Date().getTime();
        if (msec && msec <= 0) {
            this.$set(good, 'limitTime', '');
            clearInterval(this.timer);
            this.loadData();
        }
        else {
            let remainTime = Date.formatMs(msec, 'DD hh mm ss');
            let limitTime = remainTime.split(' ');
            let d;
            let t = limitTime.splice(-3).join(':');
            let day = limitTime[0];
            if (day === '00' || !day) {
                d = '';
            }
            else {
                d = Number(day) + '天';
            }
            this.$set(good, 'limitTime', `${startTimer ? '距开始' : '倒计时'}:${d}${t}`);
        }
    }
    beforeDestory() {
        this.closeTimer();
    }
    async goGoodsView(item) {
        // 微页面组件内容点击埋点
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: this.data.title,
            ContentName: item.title,
            JumpType: '商品详情',
            JumpContentName: item.title,
            JumpContentID: item.id + '_' + item._sku.id + '',
            isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName_ContentName'],
            ['p3', 'isTabPage'],
            ['p4', 'JumpType_JumpContentID_JumpContentName'],
        ]);
        if (env.type === 'ivydad') {
            await env.init();
            // let url = `${window.location.origin}/goods/goodsView?spuId=${
            //   item.id
            // }&selectSkuId=${item.from === 'sku' ? item._sku.id : ''}`
            // await env.commonJump(`ivydadreadtool://h5?url=${encodeURIComponent(url)}&navBarHide=1`)
            let _url = `ivydadreadtool://weex/product-details-page?spuId=${item.id}&selectSkuId=${item.from === 'sku' ? item._sku.id || '' : ''}`;
            await env.commonJump(_url);
        }
        else {
            this.$router.push({
                path: 'goodsView',
                query: {
                    spuId: item.id,
                    selectSkuId: item.from === 'sku' ? item._sku.id || '' : '',
                },
            });
        }
    }
};
tslib_1.__decorate([
    Prop()
], Goods.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], Goods.prototype, "actionData", void 0);
tslib_1.__decorate([
    Prop()
], Goods.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Watch('data.lineRule') // 排列规则变化,多行
], Goods.prototype, "templateChange", null);
tslib_1.__decorate([
    Watch('data.showActivityDeadtime')
], Goods.prototype, "goodsEndTimeChanged", null);
Goods = tslib_1.__decorate([
    Component({
        components: {
            GoodsTags,
        },
    })
], Goods);
export default Goods;
